import type { PublicRoute } from "../../../routes/registry";
import NotFoundPage, { NOT_FOUND_DESCRIPTION, NOT_FOUND_TITLE } from "./NotFoundPage";

/** The catch-all (BR-WEB-091): the registry renders this for every path no other screen claims. */
const route: PublicRoute = {
  path: "*",
  element: <NotFoundPage />,
  title: NOT_FOUND_TITLE,
  description: NOT_FOUND_DESCRIPTION,
};

export default route;
